import React from 'react';
import { GameMode } from '../types';
import { MODE_DEFINITIONS } from '../modes';
import { MODE_TO_SLUG } from '../router';
import { Card } from './ui/card';

interface Props {
  onSelectMode: (mode: GameMode) => void;
}

export const ModeSelection: React.FC<Props> = ({ onSelectMode }) => {
  return (
    <div className="container mx-auto w-full max-w-6xl px-4 py-12 flex flex-col items-center justify-center min-h-[calc(100dvh-3.5rem)]">
      <div className="text-center mb-8">
        <h1 className="text-4xl font-extrabold tracking-tight lg:text-5xl mb-2 text-primary">
          GeoInfinite
        </h1>
        <p className="text-muted-foreground">
          The endless geography challenge.
        </p>
      </div>

      <div className="w-full grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 lg:grid-cols-3 lg:gap-8">
        {MODE_DEFINITIONS.map((mode) => (
          <Card
            key={mode.mode}
            className="cursor-pointer transition-all hover:border-primary/50 active:scale-[0.98]"
          >
            <a
              href={`/${MODE_TO_SLUG[mode.mode]}`}
              onClick={(event) => {
                event.preventDefault();
                onSelectMode(mode.mode);
              }}
              className="block"
            >
              <div
                className="p-6 flex items-center gap-4"
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && onSelectMode(mode.mode)}
              >
                <div className="text-4xl">{mode.icon}</div>
                <div className="flex-1">
                  <h3 className="font-bold text-lg">{mode.title}</h3>
                  <p className="text-sm text-muted-foreground">{mode.description}</p>
                </div>
              </div>
            </a>
          </Card>
        ))}
      </div>
      
      <div className="mt-12 text-center text-xs text-muted-foreground">
        <p>Built with Vite + React + TS</p>
      </div>
    </div>
  );
};
